"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core/");
var _styles = require("@material-ui/core/styles");
var _RichText = _interopRequireDefault(require("../RichText"));
var __jsx = _react.default.createElement;
var socialIconStyles = (0, _styles.makeStyles)(function () {
  return {
    image: {
      display: 'block',
      width: '100%',
      maxWidth: '32px',
      marginBottom: 0
    },
    wrapper: {}
  };
});
var brandLogoStyles = (0, _styles.makeStyles)(function () {
  return {
    image: {
      display: 'block',
      width: '100%',
      marginBottom: 0,
      maxWidth: '75px'
    },
    wrapper: {}
  };
});
var LinkWrapper = function LinkWrapper(props) {
  var _props$externalUrl = props.externalUrl,
    externalUrl = _props$externalUrl === void 0 ? false : _props$externalUrl,
    linkUrl = props.linkUrl,
    linkLabel = props.linkLabel,
    className = props.className;
  var extraLinkProps = externalUrl && {
    target: '_blank',
    rel: 'noopener'
  };
  return __jsx(_core.Link, (0, _extends2.default)({
    className: className,
    href: linkUrl
  }, extraLinkProps), __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: linkLabel
    }
  }));
};
var GlobalFooter = function GlobalFooter(props) {
  var anchorId = props.anchorId,
    footerLeftContent = props.footerLeftContent,
    footerRightContent = props.footerRightContent,
    portfolioLinks = props.portfolioLinks,
    brandLogo = props.brandLogo,
    legalLinks = props.legalLinks,
    trademarkBoldText = props.trademarkBoldText,
    trademarkSmallText = props.trademarkSmallText,
    socialContent = props.socialContent;
  var socialIconClasses = socialIconStyles();
  var brandLogoClasses = brandLogoStyles();
  return __jsx("div", {
    id: anchorId,
    className: "aem-ms-footer"
  }, __jsx("div", {
    className: "aem-ms-footer--wrapper"
  }, __jsx("div", {
    className: "aem-ms-footer--main"
  }, footerLeftContent && footerLeftContent.map(function (content, contentIndex) {
    return __jsx("div", {
      key: contentIndex,
      className: "aem-ms-footer--navigationLeftSection"
    }, content.title && __jsx(_core.Typography, {
      variant: "body1",
      component: "span",
      className: "aem-ms-footer--title",
      dangerouslySetInnerHTML: {
        __html: content.title
      }
    }), content.items && content.items.map(function (item, itemIndex) {
      return __jsx(LinkWrapper, (0, _extends2.default)({
        key: itemIndex
      }, item, {
        className: "aem-ms-footer--navigationLeftLink"
      }));
    }));
  }), socialContent && socialContent.map(function (content, index) {
    return __jsx("div", {
      key: index,
      className: "aem-ms-footer--navigationLeftSection"
    }, content.title && __jsx(_core.Typography, {
      variant: "body1",
      component: "span",
      className: "aem-ms-footer--title",
      dangerouslySetInnerHTML: {
        __html: content.title
      }
    }), content.contentType === 'social-links' && content.socialLinks && content.socialLinks.map(function (item, itemIndex) {
      return __jsx(LinkWrapper, (0, _extends2.default)({
        key: itemIndex
      }, item, {
        className: "aem-ms-footer--navigationLeftLink"
      }));
    }), content.contentType === 'social-icons' && __jsx("div", {
      className: "aem-ms-footer--socialIconContainer"
    }, content.items && content.items.map(function (item, itemIndex) {
      return __jsx("div", {
        key: itemIndex,
        className: "aem-ms-footer--socialIcon"
      }, __jsx("a", {
        href: item.linkUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, __jsx("img", (0, _extends2.default)({}, item, {
        className: socialIconClasses.image,
        alt: item.alt || item.title || ''
      }))));
    })));
  }), __jsx("div", {
    className: "aem-ms-footer--mainSpacer"
  }), footerRightContent && footerRightContent.map(function (content, index) {
    return __jsx("div", {
      key: index,
      className: "aem-ms-footer--navigationRightSection"
    }, content.title && __jsx(_core.Typography, {
      variant: "body1",
      component: "span",
      className: "aem-ms-footer--title",
      dangerouslySetInnerHTML: {
        __html: content.title
      }
    }), content.contentType === 'rteText' && content.rightText && __jsx(_RichText.default, {
      text: content.rightText
    }), content.contentType === 'Img' && content.image && __jsx("img", (0, _extends2.default)({}, content.image, {
      alt: content.image.alt || content.image.title || ''
    })));
  })), __jsx("div", {
    className: "aem-ms-footer--portfolio"
  }, brandLogo && __jsx("div", {
    className: "aem-ms-footer--brandLogo"
  }, __jsx("img", (0, _extends2.default)({}, brandLogo, {
    className: brandLogoClasses.image,
    alt: brandLogo.alt || brandLogo.title || ''
  }))), portfolioLinks && portfolioLinks.map(function (link, linkIndex) {
    return __jsx(LinkWrapper, (0, _extends2.default)({
      key: linkIndex
    }, link, {
      className: "aem-ms-footer--portfolioLink"
    }));
  })), __jsx("div", {
    className: "aem-ms-footer--legal"
  }, trademarkBoldText && __jsx("div", {
    className: "aem-ms-footer--trademarkBold"
  }, __jsx(_RichText.default, {
    text: trademarkBoldText
  })), trademarkSmallText && __jsx("div", {
    className: "aem-ms-footer--trademarkSmall"
  }, __jsx(_RichText.default, {
    text: trademarkSmallText
  })), __jsx("div", {
    className: "aem-ms-footer--legalLinks"
  }, legalLinks && legalLinks.map(function (link, linkIndex) {
    return __jsx(_react.default.Fragment, {
      key: linkIndex
    }, __jsx(LinkWrapper, (0, _extends2.default)({}, link, {
      className: "aem-ms-footer--legalLink"
    })), linkIndex !== legalLinks.length - 1 && __jsx("span", {
      className: "aem-ms-footer--legalLinkSpacer"
    }, "|"));
  })))));
};
var _default = GlobalFooter;
exports.default = _default;